import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { getCompositionList } from '@/lib/formItem';
import { VForm } from 'vuetify/lib/components';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'SdsSection3CompositionForm',
  props: {
  isEditing: {
    type: Boolean,
    required: true,
  },
  isValid: {
    type: Boolean,
    required: true,
  },
  compositionId: {
    type: Number,
    required: true,
  },
},
  emits: ["update:isValid", "update:compositionId"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'update:isValid', data: boolean): void;
  (e: 'update:compositionId', data: number): void;
}), expose: any, slots: any, attrs: any }) {

const m = defineMessages({
  substanceOrMixture: '単一 or 混合物（Substance or mixture）',
});



const form = ref<InstanceType<typeof VForm> | null>(null);



const updateIsValid = (e: boolean): void => {
  emits('update:isValid', e);
};

const updateCompositionId = (e: number): void => {
  emits('update:compositionId', e);
};

onMounted((): void => {
  if (form.value) {
    form.value.validate();
  }
});

return { __sfc: true,m, form, emits, updateIsValid, updateCompositionId, getCompositionList, VForm }
}

})